import { createFileRoute } from '@tanstack/react-router'
import ListPage from '../../../../../containers/Datasets/ListPage'
import { datasetsContextSearchSchema } from './search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/datasets/'
)({
  validateSearch: datasetsContextSearchSchema,
  component: ListPage
})
